import axios from "axios";
import { useState } from "react";
import {
  FaIndustry,
  FaCogs,
  FaRobot,
  FaUser,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaHome,
  FaBuilding,
  FaSearch,
  FaLock,
  FaSun,
  FaChartLine,
  FaArrowRight,
  FaMailBulk,
} from "react-icons/fa";



const RED = "#B7191A";
const INK = "#1A1A1A";
const SUBINK = "#4B4B4B";
const BORDER = "#E4E1DC";
const CREAM = "#FAF8F5";

const styles = {
  page: {
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    color: INK,
    backgroundColor: "#FFFFFF",
    width: "100%",
    overflowX: "hidden",
    marginBottom: '10px'
  },

  /* ---------- Hero (single image, content baked into the image) ---------- */
  hero: {
    width: "100%",
    lineHeight: 0,
  },
  heroImage: {
    width: "100%",
    height: "auto",
    display: "block",
  },

  /* ---------- Form card ---------- */
  formSection: {
    maxWidth: "980px",
    margin: "-20px auto 0",
    padding: "0 24px",
    position: "relative",
    zIndex: 2,
  },
  formCard: {
    background: "#fff",
    borderRadius: "14px",
    boxShadow: "0 20px 50px rgba(0,0,0,0.12)",
    padding: "36px 32px",
  },
  formHeading: {
    textAlign: "center",
    fontSize: "24px",
    fontWeight: 800,
    margin: 0,
  },
  formHeadingAccent: {
    color: RED,
  },
  formSubheading: {
    textAlign: "center",
    marginTop: "6px",
    color: SUBINK,
    fontSize: "13px",
  },
  formGrid3: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "18px",
    marginTop: "28px",
  },
  fieldLabel: {
    display: "block",
    fontSize: "13px",
    fontWeight: 600,
    marginBottom: "6px",
    color: INK,
  },
  inputWrap: {
    display: "flex",
    alignItems: "center",
    border: `1px solid ${BORDER}`,
    borderRadius: "8px",
    padding: "0 12px",
    background: "#fff",
  },
  inputIcon: {
    color: "#9A9A9A",
    fontSize: "14px",
    marginRight: "8px",
  },
  input: {
    border: "none",
    outline: "none",
    padding: "12px 0",
    width: "100%",
    fontSize: "14px",
    background: "transparent",
    color: INK,
  },
  prefix: {
    fontSize: "14px",
    color: SUBINK,
    marginRight: "6px",
  },
  sectionLabel: {
    fontSize: "13px",
    fontWeight: 600,
    marginTop: "28px",
    marginBottom: "10px",
    display: "block",
  },
  optionGrid4: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "14px",
  },
  optionCard: (active) => ({
    border: `1.5px solid ${active ? RED : BORDER}`,
    borderRadius: "10px",
    padding: "18px 8px",
    textAlign: "center",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    color: active ? RED : INK,
    background: active ? "#FDF2F1" : "#fff",
    transition: "border-color 0.15s ease, background 0.15s ease",
  }),
  optionIcon: {
    fontSize: "22px",
  },
  optionLabel: {
    fontSize: "13px",
    fontWeight: 600,
  },
  radioGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "12px",
  },
  radioRow: (active) => ({
    display: "flex",
    alignItems: "center",
    gap: "10px",
    border: `1px solid ${active ? RED : BORDER}`,
    borderRadius: "8px",
    padding: "12px 14px",
    cursor: "pointer",
    fontSize: "13.5px",
    color: INK,
    background: active ? "#FDF2F1" : "#fff",
  }),
  radioDot: (active) => ({
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    border: `1.5px solid ${active ? RED : "#B9B9B9"}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  }),
  radioDotInner: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: RED,
  },
  consentRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    marginTop: "26px",
    fontSize: "13px",
    color: SUBINK,
  },

  submitBtn: (disabled) => ({
    width: "100%",
    marginTop: "22px",
    background: disabled ? "#D79392" : RED,
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "16px 0",
    fontSize: "15px",
    fontWeight: 700,
    letterSpacing: "0.3px",
    cursor: disabled ? "not-allowed" : "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  }),
  submitNote: {
    textAlign: "center",
    marginTop: "14px",
    fontSize: "12px",
    color: "#8A8A8A",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
  },
  statusBanner: (kind) => ({
    marginTop: "18px",
    borderRadius: "8px",
    padding: "12px 14px",
    fontSize: "13px",
    fontWeight: 500,
    textAlign: "center",
    background: kind === "error" ? "#FDECEC" : "#EAF7EE",
    color: kind === "error" ? "#B7191A" : "#1E7D3B",
    border: `1px solid ${kind === "error" ? "#F3C6C6" : "#BFE6CB"}`,
  }),

  /* ---------- Why choose ---------- */
  whySection: {
    background: CREAM,
    marginTop: "72px",
    padding: "56px 24px 64px",
  },
  whyInner: {
    maxWidth: "1100px",
    margin: "0 auto",
  },
  whyHeading: {
    textAlign: "center",
    fontSize: "26px",
    fontWeight: 800,
    margin: 0,
  },
  whyUnderline: {
    width: "56px",
    height: "3px",
    background: RED,
    margin: "14px auto 0",
    borderRadius: "2px",
  },
  whyGrid: {
    marginTop: "42px",
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "32px",
  },
  whyCard: {
    textAlign: "center",
  },
  whyIconWrap: {
    width: "64px",
    height: "64px",
    margin: "0 auto 18px",
    borderRadius: "50%",
    background: "#fff",
    border: `1px solid ${BORDER}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "26px",
    color: RED,
  },
  whyCardTitle: {
    fontSize: "15px",
    fontWeight: 700,
    margin: "0 0 8px",
  },
  whyCardText: {
    fontSize: "13px",
    color: SUBINK,
    lineHeight: 1.5,
    maxWidth: "220px",
    margin: "0 auto",
  },

  /* ---------- Banner ---------- */
  banner: {
    background: `linear-gradient(90deg, #0E1B33, #142645)`,
    color: "#ffffff",
    // padding: "28px 24px",
    position: "relative",
    overflow: "hidden",
  },
  bannerInner: {
    position: "relative",
    zIndex: 1,
    padding: "28px 24px",
    maxWidth: "1180px",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "24px",
    minHeight: "160px",
  },
  bannerImage: {
    width: "100%",
    height: "auto",
    display: "block",
  },

  bannerLeft: {
    minWidth: "220px",
  },
  bannerTitle: {
    fontSize: "18px",
    fontWeight: 700,
    margin: 0,
  },
  bannerSub: {
    fontSize: "13px",
    color: "#ffffff",
    marginTop: "4px",
  },
  bannerStats: {
    display: "flex",
    gap: "32px",
    flexWrap: "wrap",
  },
  bannerStat: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  bannerStatNum: {
    fontSize: "16px",
    fontWeight: 800,
  },
  bannerStatLabel: {
    fontSize: "11px",
    color: "#ffffff",
    lineHeight: 1.2,
  },
};

const lookingForOptions = [
  { key: "home", label: "Home", icon: FaHome },
  { key: "office", label: "Office", icon: FaBuilding },
  { key: "factory", label: "Factory", icon: FaIndustry },
  { key: "exploring", label: "Just Exploring", icon: FaSearch },
];

const billOptions = [
  "₹0 – ₹2,000",
  "₹2,000 – ₹5,000",
  "₹5,000 – ₹10,000",
  "₹10,000 – ₹25,000",
  "₹25,000 – ₹50,000",
  "₹50,000+",
];

export default function SolarSaving() {
  const [lookingFor, setLookingFor] = useState("home");
  const [bill, setBill] = useState("₹0 – ₹2,000");
  const [form, setForm] = useState({ name: "", pin: "", whatsapp: "", email: "" });

  // submission state: "idle" | "submitting" | "success" | "error"
  const [status, setStatus] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));

  const validate = () => {
    if (!form.name.trim()) return "Please enter your full name.";
    if (!/^\d{6}$/.test(form.pin.trim())) return "Please enter a valid 6-digit PIN code.";
    if (!/^\d{10}$/.test(form.whatsapp.trim()))
      return "Please enter a valid 10-digit WhatsApp number.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim()))
      return "Please enter a valid email address.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationError = validate();
    if (validationError) {
      setStatus("error");
      setErrorMessage(validationError);
      return;
    }

    setStatus("submitting");
    setErrorMessage("");

    let utm = localStorage.getItem('utm_data') || null;

    const payload = {
      name: form.name.trim(),
      pin: form.pin.trim(),
      email: form.email.trim(),
      whatsapp: form.whatsapp.trim(),
      lookingFor,
      monthlyBill: bill,
      utm
    };


    try {
      // await axios.post('http://localhost:1008/solar-saving-contact', payload);
      await axios.post('https://gautamsolar.us/solar-saving-contact', payload);

      setStatus("success");
      setForm({ name: "", pin: "", whatsapp: "", email: "" });
      setLookingFor("home");
      setBill("₹0 – ₹2,000");
    } catch (err) {
      setStatus("error");
      setErrorMessage(
        "Something went wrong while submitting your details. Please try again."
      );
    }
  };

  const isSubmitting = status === "submitting";

  return (
    <div style={styles.page}>
      <style>{`
        * { box-sizing: border-box; }
        .gs-input::placeholder { color: #9A9A9A; }

        @media (max-width: 900px) {
          .gs-form-grid3 { grid-template-columns: 1fr !important; }
          .gs-option-grid4 { grid-template-columns: repeat(2, 1fr) !important; }
          .gs-radio-grid { grid-template-columns: 1fr !important; }
          .gs-why-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
                @media (max-width: 600px) {
          .gs-why-grid { grid-template-columns: 1fr !important; }
          .gs-form-card { padding: 24px 18px !important; }
          .gs-banner-inner { 
            flex-direction: column !important; 
            align-items: flex-start !important; 
            padding: 24px 20px !important;
          }
          .gs-banner-stats { 
            flex-direction: column !important; 
            align-items: flex-start !important; 
            gap: 16px !important;
            width: 100%;
          }
        }
      `}</style>

      {/* Hero — single image, all content already designed into it */}
      <div style={styles.hero}>
        <img
          src="/site_visit.webp"
          alt="Thank you for visiting Gautam Solar"
          style={styles.heroImage}
        />
      </div>

      {/* Form */}
      <div style={styles.formSection}>
        <form className="gs-form-card" style={styles.formCard} onSubmit={handleSubmit}>
          <h2 style={styles.formHeading}>
            Get Your Free{" "}
            <span style={styles.formHeadingAccent}>Solar Site Visit</span>
          </h2>
          <p style={styles.formSubheading}>It takes less than 60 seconds!</p>

          <div className="gs-form-grid3" style={styles.formGrid3}>
            <div>
              <label style={styles.fieldLabel}>Full Name*</label>
              <div style={styles.inputWrap}>
                <span style={styles.inputIcon}><FaUser /></span>
                <input
                  className="gs-input"
                  style={styles.input}
                  type="text"
                  placeholder="Enter your full name"
                  value={form.name}
                  onChange={handleChange("name")}
                  required
                />
              </div>
            </div>

            <div>
              <label style={styles.fieldLabel}>PIN Code*</label>
              <div style={styles.inputWrap}>
                <span style={styles.inputIcon}><FaMapMarkerAlt /></span>
                <input
                  className="gs-input"
                  style={styles.input}
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  placeholder="Enter 6-digit PIN code"
                  value={form.pin}
                  onChange={handleChange("pin")}
                  required
                />
              </div>
            </div>

            <div>
              <label style={styles.fieldLabel}>WhatsApp Number*</label>
              <div style={styles.inputWrap}>
                <span style={styles.inputIcon}><FaWhatsapp /></span>
                <span style={styles.prefix}>+91</span>
                <input
                  className="gs-input"
                  style={styles.input}
                  type="tel"
                  inputMode="numeric"
                  maxLength={10}
                  placeholder="Enter WhatsApp number"
                  value={form.whatsapp}
                  onChange={handleChange("whatsapp")}
                  required
                />
              </div>
            </div>
            <div>
              <label style={styles.fieldLabel}>Email*</label>
              <div style={styles.inputWrap}>
                <span style={styles.inputIcon}><FaMailBulk /></span>
                <span style={styles.prefix}></span>
                <input
                  className="gs-input"
                  style={styles.input}
                  type="text"
                  inputMode="text"
                  placeholder="Enter Email"
                  value={form.email}
                  onChange={handleChange("email")}
                  required
                />
              </div>
            </div>
          </div>

          <label style={styles.sectionLabel}>What are you looking for?*</label>
          <div className="gs-option-grid4" style={styles.optionGrid4}>
            {lookingForOptions.map((opt) => (
              <div
                key={opt.key}
                style={styles.optionCard(lookingFor === opt.key)}
                onClick={() => setLookingFor(opt.key)}
                role="button"
                tabIndex={0}
              >
                <span style={styles.optionIcon}>
                  <opt.icon />
                </span>
                <span style={styles.optionLabel}>{opt.label}</span>
              </div>
            ))}
          </div>

          <label style={styles.sectionLabel}>Your average monthly electricity bill*</label>
          <div className="gs-radio-grid" style={styles.radioGrid}>
            {billOptions.map((opt) => (
              <div
                key={opt}
                style={styles.radioRow(bill === opt)}
                onClick={() => setBill(opt)}
                role="button"
                tabIndex={0}
              >
                <div style={styles.radioDot(bill === opt)}>
                  {bill === opt && <div style={styles.radioDotInner} />}
                </div>
                {opt}
              </div>
            ))}
          </div>



          <button type="submit" style={styles.submitBtn(isSubmitting)} disabled={isSubmitting}>
            {isSubmitting ? "SUBMITTING..." : "GET SITE VISIT"} <FaArrowRight />
          </button>

          {status === "error" && (
            <div style={styles.statusBanner("error")}>{errorMessage}</div>
          )}
          {status === "success" && (
            <div style={styles.statusBanner("success")}>
              Thanks! Our team will contact you shortly about your free site visit.
            </div>
          )}

          <div style={styles.submitNote}>
            <FaLock /> Your information is safe and will never be shared.
          </div>
        </form>
      </div>

      {/* Why choose */}
      <div style={styles.whySection}>
        <div style={styles.whyInner}>
          <h2 style={styles.whyHeading}>
            Why Choose <span style={{ color: RED }}>Gautam Solar?</span>
          </h2>
          <div style={styles.whyUnderline} />

          <div className="gs-why-grid" style={styles.whyGrid}>
            <div style={styles.whyCard}>
              <div style={styles.whyIconWrap}><FaSun /></div>
              <h3 style={styles.whyCardTitle}>Advanced Solar Technology</h3>
              <p style={styles.whyCardText}>
                High efficiency, long lasting & built for Indian conditions.
              </p>
            </div>
            <div style={styles.whyCard}>
              <div style={styles.whyIconWrap}><FaRobot /></div>
              <h3 style={styles.whyCardTitle}>Tier 1 Robotic Manufacturing</h3>
              <p style={styles.whyCardText}>
                Precision engineering for superior quality & reliability.
              </p>
            </div>
            <div style={styles.whyCard}>
              <div style={styles.whyIconWrap}><FaCogs /></div>
              <h3 style={styles.whyCardTitle}>End-to-End Solar Solutions</h3>
              <p style={styles.whyCardText}>
                From consultation to installation and after-sales support.
              </p>
            </div>
            <div style={styles.whyCard}>
              <div style={styles.whyIconWrap}><FaChartLine /></div>
              <h3 style={styles.whyCardTitle}>High Performance & Savings</h3>
              <p style={styles.whyCardText}>
                Lower electricity bills and higher return on investment.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Banner */}
      <div style={styles.banner}>
        <img src="/ribbon-banner.jpeg" alt="ribbon banner" style={styles.bannerImage} />
        {/* <div className="gs-banner-inner" style={styles.bannerInner}>
          <div style={styles.bannerLeft}>
            <h3 style={styles.bannerTitle}>Powering a Greener Tomorrow</h3>
            <p style={styles.bannerSub}>Trusted by thousands of customers across India.</p>
          </div>
          <div className="gs-banner-stats" style={styles.bannerStats}>
            <div style={styles.bannerStat}>
              <FaBolt />
              <div>
                <div style={styles.bannerStatNum}>4 GW+</div>
                <div style={styles.bannerStatLabel}>Generation Capacity</div>
              </div>
            </div>
            <div style={styles.bannerStat}>
              <FaTrophy />
              <div>
                <div style={styles.bannerStatNum}>30+</div>
                <div style={styles.bannerStatLabel}>Years Experience</div>
              </div>
            </div>
            <div style={styles.bannerStat}>
              <FaUsers />
              <div>
                <div style={styles.bannerStatNum}>30k+</div>
                <div style={styles.bannerStatLabel}>Satisfied Customers</div>
              </div>
            </div>
            <div style={styles.bannerStat}>
              <FaFlag />
              <div>
                <div style={styles.bannerStatNum}>Made in India</div>
                <div style={styles.bannerStatLabel}>For the World</div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}